import { Component, inject, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';  // Import NgForm
import { ActivatedRoute, RouterLink } from '@angular/router';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Output, EventEmitter } from '@angular/core';
import { EditProfileComponent } from "../edit-profile/edit-profile.component";
import { ServicesService } from '../my-profile/services.service';
import { ApiServicesService } from '../services/api-services.service';
import { UserDetailsService } from '../services/user-details.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-user-details',
  standalone: true,
  imports: [CommonModule, FormsModule, MatFormFieldModule, MatSelectModule, ReactiveFormsModule],
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.css']
})
export class UserDetailsComponent {
  constructor(private apiService: ApiServicesService, private userdetails: UserDetailsService, private route: ActivatedRoute) { }
  is_myProfile: boolean = true;
  private userDetailsSubscription!: Subscription;

  userData!: any;
  loader = true;
  userDetails = [
    {
      gender: '',
      age: '',
      seeking: "",
      contry: ''
    }
  ]

  ngOnInit() {

    this.userDetailsSubscription = this.userdetails.userdetails$.subscribe((userData) => {
      this.loader=true;
      this.userData = userData;
      if (userData !== null) {
        if (userData && userData.user) {
          this.userDetails[0].contry = this.userData?.user?.country?.name;
          this.userDetails[0].age = this.userData?.user?.age;
          this.userDetails[0].gender = this.userData?.user?.gender?.name;
          this.userDetails[0].seeking = this.userData?.user?.seeking_gender?.name;
          this.loader = false;
          this.is_myProfile = this.apiService.checkProfile(this.userData?.user?.username);
        }
      }
    });
  }

  ngOnDestroy() {
    if (this.userDetailsSubscription) {
      this.userDetailsSubscription.unsubscribe();
    }
  }

  

  baseUrl: string = 'http://localhost:4200';
  is_edit = 'edit_form';

  changeSettings() {
  }

  userDetailsUpdate() {
    alert("profile updated")
  }

  private taskservices = inject(ServicesService);

  openEdit() {
    this.taskservices.close_task(this.is_edit);
  }

  openViewDetails() {
    this.taskservices.isViewSubject.next("View-Details");
  }
}
